import { useGetDataQuery } from 'common/commonRedux/getRTKApi/baseApi'

export default function useProjects() {
    const {data} = useGetDataQuery({urlObjKey: "ProjectDropdown", params: {}})
    const projectsDropdown = data?.map((project: any) => ({
        label: project.projectName,
        value: project.projectId,
    })) || []
  return {projectsDropdown}
}
